import type { PaletteDesignToken } from '@primeuix/themes/types';

export type DuPrimary = 'dataunit_blue' | 'dataunit_orange';

export const DEFAULT_DU_PRIMARY: DuPrimary = 'dataunit_blue';

export const DU_PALETTES: Record<DuPrimary, PaletteDesignToken> = {
  dataunit_blue: {
    50: '#f4f5f7',
    100: '#cbd0d8',
    200: '#a2abb9',
    300: '#78869b',
    400: '#4f617c',
    500: '#263c5d',
    600: '#20334f',
    700: '#1b2a41',
    800: '#152133',
    900: '#0f1825',
    950: '#0a0f17',
  },
  dataunit_orange: {
    50: '#fffaf4',
    100: '#fde5c9',
    200: '#fbd09f',
    300: '#f9bb75',
    400: '#f7a64a',
    500: '#f59120',
    600: '#d07b1b',
    700: '#ac6616',
    800: '#875012',
    900: '#623a0d',
    950: '#3d2408',
  },
};
